import { ChartOptions } from "../../config/type/chart-options";
import { createPluginOptions } from "../create-plugin-options";

export const defaultEventBarOptions = createPluginOptions<ChartOptions>()({
	axes: {
		bottom: {
			grid: false,
		},
		left: {
			grid: true,
		},
	},
	openDialogOnClick: false,
	tootlip: false,
});

export type EventBarOptions = typeof defaultEventBarOptions;
